import { lazy } from 'react';

const CharityVettingContactDetailsEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingContactFormConfirm" */ '../components/steps/contact-form-confirm-step/ContactFormConfirmStep'
    ),
);

export default CharityVettingContactDetailsEntry;
